import { JadeMask } from "@stone-payments/jade";

const CPF_REGEX = /(\d{3}|\*{3})(\d{3})(\d{3})(\d{2}|\*{2})/g;
const CNPJ_REGEX =
  /^([a-zA-Z0-9]{2}|\*{2})([a-zA-Z0-9]{3}|\*{3})?([a-zA-Z0-9]{3}|\*{3})?([a-zA-Z0-9]{4}|\*{4})?([a-zA-Z0-9]{2}|\*{2})?/g;

const getOnlyValidCharacters = (value: string) =>
  value.replace(/[^a-zA-Z0-9]/g, "");

const formatToBrlCurrency = (amount: number = 0, hideSymbol?: boolean) => {
  const normalizedAmount = amount / 100;
  return new Intl.NumberFormat("pt-BR", {
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: hideSymbol ? "decimal" : "currency",
  })
    .format(normalizedAmount)
    .replace(/\xa0/, " ");
};

const documentType = (document: string) => {
  switch (getOnlyValidCharacters(document).length) {
    case 11:
      return "CPF";
    case 14:
      return "CNPJ";
    default:
      return "Desconhecido";
  }
};

const formatDocument = (document: string, withLabel: boolean = false) => {
  const _document = getOnlyValidCharacters(document);
  const type = documentType(_document);

  const formatCNPJ = (CNPJ?: string) =>
    CNPJ?.replace(CNPJ_REGEX, "$1.$2.$3/$4-$5") || "";

  const formatCPF = (CPF?: string) =>
    CPF?.replace(CPF_REGEX, "$1.$2.$3-$4") || "";

  if (type === "CNPJ") {
    const label = withLabel ? "CNPJ: " : "";
    return label + formatCNPJ(_document);
  }

  if (type === "CPF") {
    const label = withLabel ? "CPF: " : "";
    return label + formatCPF(_document);
  }

  return document;
};

const formatPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) {
    return "";
  }

  const mask = new JadeMask("(99) 99999-9999", "(99) 9999-9999");
  const phoneNumberWithoutCountryCode = phoneNumber.replace(/^\+(\d{2})/, "");

  return mask.compile(phoneNumberWithoutCountryCode);
};

const BRAZIL_COUNTRY_CODE = "55";

const phoneToE164 = (phoneNumber: string) => {
  const digits = phoneNumber.replace(/\D/g, "");

  if (!digits) {
    return "";
  }

  return `+${BRAZIL_COUNTRY_CODE}${digits}`;
};

export const Mask = {
  documentType,
  formatToBrlCurrency,
  formatDocument,
  formatPhoneNumber,
  phoneToE164,
};
